<template>
  <section class="section section-shaped section-lg my-0">
    <div class="shape shape-style-1 bg-gradient-default">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div class="container pt-lg-md">
      <div class="row justify-content-center">
        <div class="col-lg-5">
          <card type="secondary" shadow
                header-classes="bg-white pb-5"
                body-classes="px-lg-5 py-lg-5"
                class="border-0">
            <template>
              <div v-if="login_errado" class="alert alert-danger" role="alert">
                Número de inscrição ou CPF inválido.
              </div>
              <div class="text-muted text-center mb-3">
                <small>Entre com:</small>
              </div>
              <div class="btn-wrapper text-center">
              </div>
            </template>
            <template>
              <form @submit.prevent="envia_login" role="form">
                <base-input v-model="username" alternative
                            class="mb-3"
                            v-mask="'#######-#'"
                            placeholder="Número de inscrição"
                            addon-left-icon="ni ni-single-02">
                </base-input>
                <base-input v-mask="'###.###.###-##'" v-model="password" alternative

                            placeholder="CPF"
                            addon-left-icon="ni ni-badge">
                </base-input>

                <div class="text-center">
                  <base-button native-type="submit" type="primary" class="my-4">Entrar</base-button>
                </div>
              </form>
            </template>
          </card>
          <div class="row mt-3">
            <div class="col-6">
              <a href="#" class="text-light">
                <!--                <small>Esqueci minha senha</small>-->
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import axios from 'axios';
import {useRouter} from 'vue-router';
import Vue from 'vue'
import vueCrypt from 'vue-crypt'
import {cpf} from "cpf-cnpj-validator";

export default {
  name: 'Login',
  data() {
    return {
      username: '',
      password: '',
      login_errado: false,
      logins: [{cpf: 321., num_cand: 123}]
    }
  },
  methods: {
    envia_login: async function () {

      const encryptedText = this.CryptoJS.AES.encrypt("Hi There!", 'secret key 123').toString()
      const decryptedText = this.CryptoJS.AES.decrypt('U2FsdGVkX1+rGzJrqd1xvB4s0Sxxmcl9dbo4sUwcMsE=', 'secret key 123').toString(this.CryptoJS.enc.Utf8)

      const encrypt = (texto) => {
        return this.CryptoJS.AES.encrypt(texto, 'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString()
      }
      const decrypt = (texto) => {
        return this.CryptoJS.AES.decrypt(texto, 'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString(this.CryptoJS.enc.Utf8);
      }

      const gera_file_name = (cpf, num_cand) => {

        let candidato = {CPF: cpf, NUMEROINSC: num_cand}
        let cod_projeto = '2106_pt'
        let codigo_meio = candidato.CPF.replace(/\./g, '').replace('-', '') * 7919;
        codigo_meio = codigo_meio.toString()

        let codigo_arquivo = parseInt(codigo_meio.substring(0, 5)) * parseInt(candidato.NUMEROINSC.replace('-', '')) * 13 + '_'
            + String.fromCharCode(65 + parseInt(codigo_meio[3]))
            + String.fromCharCode(parseInt(codigo_meio[1] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[1]))
            + String.fromCharCode(parseInt(codigo_meio[4] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[5]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[2]))
            + String.fromCharCode(parseInt(codigo_meio[7] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[7]))
            + '-'
            + String.fromCharCode(parseInt(codigo_meio[0] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[11]))
            + String.fromCharCode(parseInt(codigo_meio[1] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[9]))
            + String.fromCharCode(parseInt(codigo_meio[5] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[4]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[5]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[8]))
            + '_'
            + String.fromCharCode(parseInt(codigo_meio[2] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[3]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[4]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[6]))
            + String.fromCharCode(parseInt(codigo_meio[6] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[2]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[11]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[9]))

        return codigo_arquivo + '.pdf';
      }


      let cands =
[{"num_cand":"U2FsdGVkX1+g5k3nDAH7pRHZvwdwJQvfWKtl5q7KnTs=","cpf":"U2FsdGVkX18DVG3Ev54Zv8t94W0SCyyjj2DzunS00Ck="},{"num_cand":"U2FsdGVkX1/VFkBe3gbv20WDIgQKyx5gCUiv8mmZiKg=","cpf":"U2FsdGVkX1819P0hu2Z5AI8acCk355zIbX5OV0fb/KU="},{"num_cand":"U2FsdGVkX1+ptbJwfFwlhHIJrZfMQSeLYEBlnlwVNdM=","cpf":"U2FsdGVkX19Cvk9lf4A9nQ2MCOgV0rCKKQgeK7Z2h4o="},{"num_cand":"U2FsdGVkX18pSNOQVlDL89sGDKwBpsMxjcSElxvIUNg=","cpf":"U2FsdGVkX19hXayDf4G/SlR0cLseryrJBw332Aut8NQ="},{"num_cand":"U2FsdGVkX18n3CEqIV9C/7PL38YXZ1qt6T5XZRBQYuc=","cpf":"U2FsdGVkX1+SyQP7n7wVi+zbXMWsymZaAYPPahSv0gI="},{"num_cand":"U2FsdGVkX1/FSlswK0KdJdzfcLW0pMhYuC6IqsslqBw=","cpf":"U2FsdGVkX19sU7eA0K82ABP4Ukp20AA6+5fNhgkBU04="},{"num_cand":"U2FsdGVkX18I7PM+mhZJP+yrUqWfq9lMW2q3aHfBMFg=","cpf":"U2FsdGVkX1/AofHfNhNRVxRcebZ0c6ucg7F1/SWEKg0="},{"num_cand":"U2FsdGVkX18qTl7c+PJeEoVeqUjqH0Go2ftzznKiyIw=","cpf":"U2FsdGVkX19eJJwPtZ7+z4wz8zPFzCI9CZGvwj606Ms="},{"num_cand":"U2FsdGVkX1+24m2ukOSV8BoB30EZDsHJuSFsoB06oI0=","cpf":"U2FsdGVkX1/6Fybq6R68AL5DXhVfKNkmwXcXmqBsfSE="},{"num_cand":"U2FsdGVkX1/AiynFTYscSuq3DTqdxm4qoZR2y3kr7X0=","cpf":"U2FsdGVkX19C3q6Qt/yFnqlLF4Lq7rJNLcmk3mKywvI="},{"num_cand":"U2FsdGVkX18CEI1kNtvruN8gisKgwgUjtXUfgiB3ze0=","cpf":"U2FsdGVkX1980ua7O1+Um3CBQFOxU65ObyM76CHlFOQ="},{"num_cand":"U2FsdGVkX1+0BTPgp78Q2jMBhb93BPEVN+6u4lAoqRY=","cpf":"U2FsdGVkX1/4/KyjX25/HPhXGIXM+rNQ7ri3kqWJMO4="},{"num_cand":"U2FsdGVkX19HiV8uPh2g0MCa1oAfkE1QqHhC6LT7OU4=","cpf":"U2FsdGVkX19hCdtH8cUNpwqqSOcO22/MpxKHxAiGEFQ="},{"num_cand":"U2FsdGVkX1+LPFoWik8bu4S/4vqsT+J6q2Bws1PN/gQ=","cpf":"U2FsdGVkX1/6mHLGt8mKE02j87za3uhmME25a2e30Vk="},{"num_cand":"U2FsdGVkX1/yFrych/jSao/3rwbE46NpMuhadZB15EM=","cpf":"U2FsdGVkX18asyFK6v5O/SitHljFdQF3SOqLb6q2Wd4="},{"num_cand":"U2FsdGVkX189g+qE52hHt9OkNHQMCqRM8aIWZqdKfCY=","cpf":"U2FsdGVkX1+HOU1OCSk1veSt6czEqsAL2Gcfdz4WlPw="},{"num_cand":"U2FsdGVkX18eh/PLBGcxQA+WXkG3L1PhekeLPTSDiF8=","cpf":"U2FsdGVkX18H4P+Z8kYdcf6EQGB/YhD0c/kyoTomGw4="},{"num_cand":"U2FsdGVkX19GX1DsCz6e7yJGb0OKdLqN1290YMYEa+g=","cpf":"U2FsdGVkX199Jr8jaw1LEp6uJHGb0Sme1pIMOqZb3QI="},{"num_cand":"U2FsdGVkX1/8wY8YL2y+I5DHmFxk4sszKEU07xXxTLM=","cpf":"U2FsdGVkX19tlfsetxxC2NdcFVgL2FX8mbtPr2HQEG0="},{"num_cand":"U2FsdGVkX196dOWIhLVh+Gv0wOQ5vvFwpD+7vcvODVc=","cpf":"U2FsdGVkX1/UwiI0PlQ0qMb4TUsIiUzuog590jqUnB4="},{"num_cand":"U2FsdGVkX1+UjrJovNWKN0vw4c04T7XCPkBIbLDE/Ak=","cpf":"U2FsdGVkX1+GYgDgQGIQyHYFlj78hZ1nbTJiSRF5uVo="},{"num_cand":"U2FsdGVkX19WAhYly0t+6tK0l6jdLuCTv6p59OIu+XU=","cpf":"U2FsdGVkX1/vlbbMd4ze64NK9FUL3S0bd7t5IBZTRfM="},{"num_cand":"U2FsdGVkX1+vPaStwiOO55Wm0sHhj9ePKn1AfDSAwio=","cpf":"U2FsdGVkX19eR8rGWwNwmdngUj25I52nr12tOQqORrk="},{"num_cand":"U2FsdGVkX1+jZzpffC3/BCnAxUsH6J+wW96tPBYMvKQ=","cpf":"U2FsdGVkX1/K9d0FpfzdtFcxhPHCDT7rQXUrp9gh3pQ="},{"num_cand":"U2FsdGVkX1/6wzBcQRmC83Dl41a6+XwBZi4cPdFcTfE=","cpf":"U2FsdGVkX18niXZnm5VD9T9gyr/1RfJza7aP+3Hc9eY="},{"num_cand":"U2FsdGVkX18md/yBjRjm7Kv/GBkJWmwAM29kr6jXyjY=","cpf":"U2FsdGVkX18QSD2C5S0Y/TV1oawsWzbl3dGQjURJDY4="},{"num_cand":"U2FsdGVkX1/vm0I8WLjiHOhg077nqkQ3mjyd/JFFkjc=","cpf":"U2FsdGVkX184aJQYFLX+RqzuiVOy24Fh1Gz1M40R4xM="},{"num_cand":"U2FsdGVkX19PTQxEuLPeS8WLr1F3tsdpNDZZX/EvIy8=","cpf":"U2FsdGVkX18betpRvAH/ylxIiRfSL/zbFRF+zUWGwfs="},{"num_cand":"U2FsdGVkX19nsl7ILPNmgOUguZcM5SxRYmbvlFqlsVQ=","cpf":"U2FsdGVkX1+Q1jLB2xbp96loL4O+41ec67feiCsc1gY="},{"num_cand":"U2FsdGVkX18C+63esi+c6HLjjJb0/mQFp+druW8LiZ4=","cpf":"U2FsdGVkX19jkmo4y85s9mdzpbFifx4ViCtNfiijcbk="},{"num_cand":"U2FsdGVkX1/03ads1zfgyhYl3epUIX6ZPuKpAzvZpTE=","cpf":"U2FsdGVkX1+o1BWbzMBwmrVR1H4e580U228h5rsqSRs="},{"num_cand":"U2FsdGVkX1+AXTNkUcbOwDGIyIIF4YBpAftPceluQ3E=","cpf":"U2FsdGVkX193f62wwpjXcm4lGCdec0/R8u1rkUjjkA0="},{"num_cand":"U2FsdGVkX18J5PenELF7WGJEfEuqVF1RxZzvjwzgoNo=","cpf":"U2FsdGVkX18Bn4Pq4uq04CxkFt/C/uCOCaMM3u3xAmU="},{"num_cand":"U2FsdGVkX1/PFFczAZlkiYh0dUoAeQl1tHx7htSw6Dw=","cpf":"U2FsdGVkX1/7PY462KY4L72p/Jv+jHrZn5YGAlFESiQ="},{"num_cand":"U2FsdGVkX1+yoFzPsUm509fPDIphhZuag0vi0kbnCtI=","cpf":"U2FsdGVkX18WaNiP7rTfUjg1RzsZJY7d9E8zo+4GqgE="},{"num_cand":"U2FsdGVkX19bRnrwD1A/lYzVxfxtgl3NVD51jb0AXfw=","cpf":"U2FsdGVkX1/LIzV9o0HBhKRD5N0Xku8REn+kCnPMl3c="},{"num_cand":"U2FsdGVkX1/DChBHoLLwJqkb7nHsEP+qWYtCzOwbIa8=","cpf":"U2FsdGVkX1/M41YLfH2K2PlPrOBzE4nm0IXLuPwhvMA="},{"num_cand":"U2FsdGVkX19H6dicbgBdX7cGa96epFlcvNVxwH02+lQ=","cpf":"U2FsdGVkX18qNgQuZj85kpaJV91kDB+FfMMtpT35KYo="}]
      try {
        let concurso = this.$route.params.concurso;
        localStorage.setItem('concurso', concurso);

        for (let login of cands) {
          let num_cand_decripted = decrypt(login.num_cand);
          let cpf_decripted = decrypt(login.cpf);

          // console.log(num_cand_decripted,cpf_decripted)
          if (num_cand_decripted == this.username && cpf_decripted == this.password) {
            console.log(`Logged`)
            let nome_arquivo = (gera_file_name(cpf_decripted, num_cand_decripted))
            nome_arquivo = nome_arquivo.replace(/\x00/g, '-');


            // alert(`Logou`);
            let url = (`https://fs.ibfc.org.br/arquivos/2219/rec_isen/${nome_arquivo}`)
            return window.location = url;
          }
        }

        throw new Error(`Login inválido`);


      } catch (error) {
        console.log(error);
        this.login_errado = true;
      }
    }
  }
};
</script>
<style>
</style>
